<script>
    import {Container,Input,Button,Field} from 'svelte-chota';
    import {router} from 'tinro';
    import Header from './Header.svelte';
    import {aoviSvelte} from 'aovi-svelte';
    import {api} from './../lib/api.js'; 
    import {mdiFormTextboxPassword} from '@mdi/js';
    import {generatePassword} from './../lib/tools.js';

    const form = aoviSvelte({
        user: '',
        password: ''
    });

    let loading = false;
    async function doCreateUser(){
        loading = true;
        let result = await api.post('/user',form.get());
        result.error ? form.load(result.error.aovi) : router.goto('/admin/users');
        loading=false;
    }
</script>

<Header title="Create user" button="Cancel" link="/admin/users" type="error"/>

<Container class="center-500">
    <Field label="User name" error={$form.err.user}>
        <Input bind:value={$form.user}/>
    </Field>

    <Field label="User password" error={$form.err.password} gapless>
        <Input id="newpass"  bind:value={$form.password} />
        <Button icon={mdiFormTextboxPassword} primary on:click={()=>$form.password=generatePassword(8)}/>
    </Field>

    <p class="text-center">
        <Button primary on:click={doCreateUser} {loading}>Create</Button>
    </p>
</Container>